import GET_CATEGORIES from "../plugins/getCategories";
import GET_ARTICLES from "../plugins/getArticles";

import 'slick-carousel'

const w = window

export default function HOME() {

  $(() => {
  
    // トップページカスタム
    $.topInit();
  
    // ブロック整形
    (function(__){ $.each(__, $.topBlockCustomizer) }({
      'news':{
        button:{
          disp: true,
          text: 'VIEW ALL',
          attr: {
            class: 'button button-secondary c-btn-icon-right'
          }
        },
        title:{
          html: '<span>NEWS</span><small>新着情報</small>' // プレーンテキストで動的にする場合は false
        },
        itemlayout: function($this,$catetitle,$date,$new,$title){
          $this
          .append( $date )
          .append( $catetitle )
          .append( $title.append($new) )
        }
      },
    }));
  
  });

  $(()=>{
    if( w.load['block-column'] ){
      w.load['block-column'].done(()=> {
        GET_CATEGORIES('.p-block-column [data-plugin="getCategories"]')
        GET_ARTICLES('.p-block-column [data-plugin="getArticles"]',{
          makeItem(item){
            return $(`
              <a href="${item.href}" class="p-block-column__item">
                <figure class="p-block-column__item-thumb">
                  <div class="p-block-column__item-thumb-img" style="background-image:url(${item.thumb})"><img src="${item.thumb}" width="220" alt="${item.title}"></div>
                </figure>
                <div class="p-block-column__item-body">
                  <p class="category">${item.category.name}</p>
                  <h5 class="p-block-column__item-title">${item.title}</h5>
                  <p class="p-block-column__item-desc">${$.strip_tags(item.body).str_truncate(119)}</p>
                </div>
              </a>
            `)[0]
          }
        })
      })
    }


    if( w.load['block-works'] ){
      w.load['block-works'].done(() => {
        const slickopt = {
          autoplay: true,
          fade: false,
          speed: 200,
          pauseOnHover: false,
          pauseOnFocus: false,
          arrows: false,
          infinite: true,
          variableWidth: true,
          swipeToSlide:true,
          slidesToShow: 4,
          responsive: [{
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
            }
          }, {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
              infinite: true,
              centerMode: true
            }
          }]
        }
        GET_ARTICLES('.p-block-works [data-plugin="getArticles"]',{
          makeItem(item){
            return $(`
              <a href="${item.href}" class="p-block-works__item">
                <p class="p-block-works__item-category">${item.category.name}</p>
                <figure class="p-block-works__item-media">
                  <div class="p-block-works__item-img" style="background-image:url(${item.thumb})">
                    <img src="${item.thumb}" alt="${item.title}" width="300">
                  </div>
                  <figcaption class="p-block-works__item-desc">
                    <strong>${item.title}</strong>
                    <p>${$.strip_tags(item.desc).str_truncate(32)}</p>
                  </figcaption>
                </figure>
              </a>
            `)[0]
          }
        }).done(() => $('.p-block-works__list').slick(slickopt) )
      })
    }

    if( w.load['block-estate'] ){
      w.load['block-estate'].done(() => {
        GET_ARTICLES('.p-block-estate [data-plugin="getArticles"]',{
          makeItem(item){
            return $(`
              <a href="${item.href}" class="p-block-estate__item">
                <p class="p-block-estate__item-category">${item.category.name}</p>
                <div class="p-block-estate__item-media">
                  <figure class="p-block-estate__item-thumb">
                    <div class="p-block-estate__item-thumb-img" style="background-image:url(${item.thumb})">
                      <img src="${item.thumb}" alt="${item.title}" width="220">
                    </div>
                  </figure>
                  <div class="p-block-estate__item-desc">
                    <strong>${item.title}</strong>
                    <p>${$.strip_tags(item.desc).str_truncate(32)}</p>
                  </div>
                </div>
                <div class="p-block-estate__item-noteEffect"></div>
              </a>
            `)[0]
          }
        })
      })
    }

  })
}